import type { RHFGroupFieldValue } from '@/components/dynamic-filter/FilterFormGroup';
import type { TaskTypeResponse } from '@/types/apps/task-type.type';
import type { GqlListResponse } from '@/types/common/api.type';
import { BaseService } from '@/types/service/graphql-service.type';

export interface TaskTypeServiceInterface {}

type TaskCheckTypeGraphQLListResponse = GqlListResponse<TaskTypeResponse>;

export class TaskCheckTypeGraphQLService
    extends BaseService
    implements TaskTypeServiceInterface
{
    public getEntityName(): string {
        return 'taskCheckType';
    }

    public getFields(): Record<string, any> {
        return {
            createdBy: true,
            createdDate: true,
            deletedAt: true,
            deletedBy: true,
            description: true,
            id: true,
            isDeleted: true,
            modifiedBy: true,
            modifiedDate: true,
            name: true,
            taskCheckTypeEnum: true,
            templatecheckId: true,
            templateCheck: {
                code: true,
                createdDate: true,
                description: true,
                id: true,
                name: true,
            },
        };
    }

    public async index(
        query: string
    ): Promise<TaskCheckTypeGraphQLListResponse> {
        return this.fetchGqlList<TaskCheckTypeGraphQLListResponse>(
            query,
            this.getEntityName()
        );
    }

    public getFilterByRole(): Record<string, RHFGroupFieldValue> {
        if (!this.getQueryById() || !this.getRoleTypeManager().getQuery) {
            return {};
        }

        return this.getRoleTypeManager().getQuery('taskCheckType', {
            userId: this.getQueryById(),
        });
    }
}
